// extracted by mini-css-extract-plugin
export default {"root":"FieldNumberInput_root__A09XI","numberInput":"FieldNumberInput_numberInput__pzXa3","display":"FieldNumberInput_display__QgJV+","button":"FieldNumberInput_button__ut7pe"};